import Cookies from "js-cookie";

const TokenKey = "vue_admin_company_token";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  let type = process.env.VUE_APP_MEETYOU_EN_API;
  let domain = "";
  if (type == "/api") {
    domain = "localhost";
  } else if (type.indexOf(".dev.mty360.com") > 0) {
    domain = ".dev.mty360.com";
  } else if (type.indexOf("mty360.com") > 0) {
    domain = ".mty360.com";
  }
  return Cookies.set(TokenKey, token, {
    expires: 1000,
    path: "/",
    domain,
  });
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

// 上个版本 文件上传
export const upload = {
  url: `${process.env.VUE_APP_MEETYOU_EN_API}/api/enterprise/upload/add`,
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
  params: {
    type: "advertising",
  },
};

